export default __webpack_public_path__ + "static/media/faq-icon.8817b06f.svg";